import { useEffect, useState } from "react";
import ArtFrame from "./ArtFrame";
import Overlay from "./Overlay";

const BlockLabel = ({ children }) => (
  <span className="font-tech text-[9px] tracking-[0.3em] text-[#D4AF37]/80 uppercase">{children}</span>
);

const HeroesArchive = ({ characters }) => {
  const [activeHero, setActiveHero] = useState(null);

  const openHero = (c) => {
    window.history.pushState({ cdHero: c.id }, "");
    setActiveHero(c);
  };

  const closeHero = () => {
    setActiveHero(null);
    if (window.history.state?.cdHero) window.history.back();
  };

  useEffect(() => {
    const onPop = () => setActiveHero(null);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const HoverVeil = (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-black/0 opacity-0 transition-all duration-500 group-hover:bg-black/25 group-hover:opacity-100">
      <span className="border border-[#D4AF37]/40 bg-black/50 px-4 py-2 font-mono text-[9px] tracking-[0.35em] text-[#D4AF37] backdrop-blur-sm">
        EXPLORE →
      </span>
    </div>
  );

  return (
    <>
      <div className="grid grid-cols-2 gap-5 md:grid-cols-4 md:gap-6 lg:mx-auto lg:max-w-[90%]">
        {characters.map((c) => (
          <div
            key={c.id}
            data-testid={`character-card-${c.id}`}
            className="group relative cursor-pointer"
            onClick={() => openHero(c)}
            role="button"
            aria-label={`Explore ${c.name}`}
          >
            <ArtFrame
              image={c.image}
              hue={c.hue}
              ratio="aspect-[3/4]"
              label={`PORTRAIT — ${c.name}`}
              className="border border-white/10 transition-colors duration-700 group-hover:border-[#D4AF37]/40"
            >
              {HoverVeil}
            </ArtFrame>
            <div className="mt-4">
              <h3 className="text-lg tracking-wider text-[#F5F5FA] transition-colors duration-500 group-hover:text-[#D4AF37]">
                {c.name}
              </h3>
              <span
                data-testid={`hero-explore-${c.id}`}
                className="mt-3 inline-block font-mono text-[10px] tracking-[0.3em] text-[#A0A0B0] transition-colors duration-500 group-hover:text-[#D4AF37]"
              >
                EXPLORE CHARACTER →
              </span>
            </div>
          </div>
        ))}
      </div>

      <Overlay
        open={!!activeHero}
        onClose={closeHero}
        title={activeHero ? activeHero.name : ""}
        label={activeHero ? `${activeHero.universe} — HERO PROFILE` : ""}
        testid="hero-overlay"
        z={98}
      >
        {activeHero && (
          <div className="mx-auto max-w-3xl space-y-12">
            <div>
              <h3 className="font-serif text-2xl md:text-3xl tracking-wide text-[#F5F5FA]" data-testid="hero-who-heading">
                {activeHero.who || `WHO IS ${activeHero.name}?`}
              </h3>
              <span className="mt-5 block h-px w-16 bg-gradient-to-r from-[#D4AF37]/60 to-transparent" />
              <div className="mt-7 space-y-5">
                {activeHero.profile?.map((p, i) => (
                  <p key={i} className="max-w-2xl text-sm md:text-base font-light leading-relaxed text-[#A0A0B0]">
                    {p}
                  </p>
                ))}
              </div>
            </div>
            {activeHero.superpower && (
              <div data-testid="hero-superpower">
                <BlockLabel>SUPERPOWER:</BlockLabel>
                <p className="mt-3 font-mono text-[11px] leading-loose tracking-[0.15em] text-[#F5F5FA] uppercase">
                  {activeHero.superpower}
                </p>
              </div>
            )}
            {activeHero.weapon && (
              <div data-testid="hero-weapon">
                <BlockLabel>WEAPON:</BlockLabel>
                <p className="mt-3 max-w-2xl text-sm md:text-base font-light leading-relaxed text-[#A0A0B0]">
                  {activeHero.weapon}
                </p>
              </div>
            )}
            {activeHero.world && (
              <div data-testid="hero-world">
                <BlockLabel>WORLD:</BlockLabel>
                <p className="mt-3 font-mono text-[11px] tracking-[0.15em] text-[#F5F5FA] uppercase">{activeHero.world}</p>
              </div>
            )}
            {activeHero.story?.length > 0 && (
              <div data-testid="hero-story">
                <BlockLabel>THE STORY</BlockLabel>
                <div className="mt-5 space-y-3">
                  {activeHero.story.map((q) => (
                    <p key={q} className="font-serif text-base md:text-lg tracking-wide text-[#F5F5FA]/90">{q}</p>
                  ))}
                </div>
                {activeHero.book && (
                  <p className="mt-6 font-mono text-[10px] tracking-[0.25em] leading-relaxed text-[#D4AF37]/80 uppercase">
                    {activeHero.book}
                  </p>
                )}
              </div>
            )}
          </div>
        )}
      </Overlay>
    </>
  );
};

export default HeroesArchive;
